// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"684":"de3e5fa7","777":"cc6c8c4f","869":"1fb73b2a"}[chunkId] + ".chunk.css";
};